import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    const response = await axios.get("/refresh", {
      withCredentials: true,
    });
    setAuth((prev) => {
      // console.log(JSON.stringify(prev));
      // console.log(response.data.accessToken);
      return {
        ...prev,
        userCode: response.data.userCode,
        role: response.data.role,
        accessToken: response.data.accessToken,
        userID: response.data.userID,
      };
    });
    return response.data.accessToken;
  };
  return refresh;
};

export default useRefreshToken;
